import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip
} from 'recharts';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div style={{
        backgroundColor: '#fff',
        padding: '12px',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
      }}>
        <p style={{ fontWeight: '600', color: data.color }}>{data.name}</p>
        <p style={{ color: '#6b7280' }}>{data.count} adet</p>
      </div>
    );
  }
  return null;
};

const CustomLegend = ({ payload }) => (
  <div style={{ 
    display: 'flex', 
    flexWrap: 'wrap', 
    justifyContent: 'center', 
    gap: '12px',
    marginTop: '16px'
  }}>
    {payload.map((entry, index) => (
      <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <div style={{ 
          width: '12px', 
          height: '12px', 
          backgroundColor: entry.color,
          borderRadius: '2px'
        }} />
        <span style={{ fontSize: '13px', color: '#374151' }}>
          {entry.payload.name} ({entry.payload.count})
        </span>
      </div>
    ))}
  </div>
);

const PortCallChart = ({ data, loading }) => {
  if (loading) {
    return (
      <div style={{ 
        height: '280px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        color: '#6b7280'
      }}>
        Yükleniyor...
      </div>
    );
  }

  if (!data || !data.by_status || data.by_status.length === 0) {
    return (
      <div style={{ 
        height: '280px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        color: '#6b7280'
      }}>
        Veri bulunamadı
      </div>
    );
  }

  const chartData = data.by_status.map(item => ({
    ...item,
    value: item.count
  }));

  return (
    <div>
      <ResponsiveContainer width="100%" height={220}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={80}
            paddingAngle={2}
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
      <CustomLegend payload={chartData.map(item => ({ 
        color: item.color, 
        payload: item 
      }))} />
      
      {/* Summary Stats */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        gap: '24px', 
        marginTop: '16px',
        paddingTop: '16px',
        borderTop: '1px solid #e5e7eb'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#1e3a5f' }}>
            {data.total || 0}
          </div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>Toplam</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#34d399' }}>
            {data.active || 0}
          </div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>Aktif</div>
        </div>
      </div>
    </div>
  );
};

export default PortCallChart;
